import { defineMessage } from 'services/localization';

export const messages = {
    sourceXero: defineMessage('provided_by_xero'),
    sourceQBooks: defineMessage('provided_by_quickbooks_online'),
    sourceNetSuite: defineMessage('provided_by_netsuite'),
    sourceOpenExchangeRate: defineMessage('provided_by_openexchangeratesorg'),
    sourceFixer: defineMessage('provided_by_fixerio'),
    sourceCoinLayer: defineMessage('provided_by_coinlayercom'),
    sourceBills: defineMessage('provided_by_each_included_bill'),
    sourceManual: defineMessage('adjusted_manually_by_requester'),
};
